// @ts-nocheck

import { createAction, createSlice } from '@reduxjs/toolkit';
import { employeeApi, employeeDocumentApi } from './../lib/api';
import { employeeDocumentTypeEnum } from '../lib/enum';
import type { Employee } from '../lib/types';
export const FETCH_EMPLOYEE = 'vehicles/employee/fetch';
export const CLEAN_EMPLOYEE = 'vehicles/employee/clean';
const initialState = null as Employee | null;
const fetchEmployeeAction = createAction<Employee>(FETCH_EMPLOYEE);
const cleanEmployeeAction = createAction(CLEAN_EMPLOYEE);
const employeeSlice = createSlice({
  name: 'employee',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchEmployeeAction, (state, {
      payload
    }) => ({
      ...payload
    })).addCase(cleanEmployeeAction, () => null);
  }
});
export const employeeActions = {
  fetch: fetchEmployeeAction,
  clean: cleanEmployeeAction
};
export const addEmployee = employee => async dispatch => {
  const added = await employeeApi.addEmployee(employee);
  const {
    id: employeeId
  } = added;
  if (employee.riggerDocument) {
    await employeeDocumentApi.addDocument({
      ...employee.riggerDocument,
      documentType: employeeDocumentTypeEnum.rigger,
      employeeId
    });
  }
  if (employee.lulechnikDocument) {
    await employeeDocumentApi.addDocument({
      ...employee.lulechnikDocument,
      documentType: employeeDocumentTypeEnum.lulechnik,
      employeeId
    });
  }
  if (employee.safetyTechnicianDocument) {
    await employeeDocumentApi.addDocument({
      ...employee.safetyTechnicianDocument,
      documentType: employeeDocumentTypeEnum.safetyTechnician,
      employeeId
    });
  }
  if (employee.safetyCarLiftDocument) {
    await employeeDocumentApi.addDocument({
      ...employee.safetyCarLiftDocument,
      documentType: employeeDocumentTypeEnum.safetyCarLift,
      employeeId
    });
  }
  if (employee.controllerGpmDocument) {
    await employeeDocumentApi.addDocument({
      ...employee.controllerGpmDocument,
      documentType: employeeDocumentTypeEnum.controllerGpm,
      employeeId
    });
  }
  if (employee.carLiftOperatorDocument) {
    await employeeDocumentApi.addDocument({
      ...employee.carLiftOperatorDocument,
      documentType: employeeDocumentTypeEnum.carLiftOperator,
      employeeId
    });
  }
  if (employee.truckCranesMachinistDocument) {
    await employeeDocumentApi.addDocument({
      ...employee.truckCranesMachinistDocument,
      documentType: employeeDocumentTypeEnum.truckCranesMachinist,
      employeeId
    });
  }
  if (employee.manipulatorCranesOperatorDocument) {
    await employeeDocumentApi.addDocument({
      ...employee.manipulatorCranesOperatorDocument,
      documentType: employeeDocumentTypeEnum.manipulatorCranesOperator,
      employeeId
    });
  }
};
export const updateEmployee = employee => async (dispatch, getState) => {
  const updated = await employeeApi.updateEmployee(employee);
  const {
    id: employeeId
  } = updated;
  if (employee.riggerDocument) {
    if (employee.riggerDocument.id) {
      await employeeDocumentApi.updateDocument(employee.riggerDocument);
    } else {
      await employeeDocumentApi.addDocument({
        ...employee.riggerDocument,
        documentType: employeeDocumentTypeEnum.rigger,
        employeeId
      });
    }
  }
  if (employee.lulechnikDocument) {
    if (employee.lulechnikDocument.id) {
      await employeeDocumentApi.updateDocument(employee.lulechnikDocument);
    } else {
      await employeeDocumentApi.addDocument({
        ...employee.lulechnikDocument,
        documentType: employeeDocumentTypeEnum.lulechnik,
        employeeId
      });
    }
  }
  if (employee.safetyTechnicianDocument) {
    if (employee.safetyTechnicianDocument.id) {
      await employeeDocumentApi.updateDocument(employee.safetyTechnicianDocument);
    } else {
      await employeeDocumentApi.addDocument({
        ...employee.safetyTechnicianDocument,
        documentType: employeeDocumentTypeEnum.safetyTechnician,
        employeeId
      });
    }
  }
  if (employee.safetyCarLiftDocument) {
    if (employee.safetyCarLiftDocument.id) {
      await employeeDocumentApi.updateDocument(employee.safetyCarLiftDocument);
    } else {
      await employeeDocumentApi.addDocument({
        ...employee.safetyCarLiftDocument,
        documentType: employeeDocumentTypeEnum.safetyCarLift,
        employeeId
      });
    }
  }
  if (employee.controllerGpmDocument) {
    if (employee.controllerGpmDocument.id) {
      await employeeDocumentApi.updateDocument(employee.controllerGpmDocument);
    } else {
      await employeeDocumentApi.addDocument({
        ...employee.controllerGpmDocument,
        documentType: employeeDocumentTypeEnum.controllerGpm,
        employeeId
      });
    }
  }
  if (employee.carLiftOperatorDocument) {
    if (employee.carLiftOperatorDocument.id) {
      await employeeDocumentApi.updateDocument(employee.carLiftOperatorDocument);
    } else {
      await employeeDocumentApi.addDocument({
        ...employee.carLiftOperatorDocument,
        documentType: employeeDocumentTypeEnum.carLiftOperator,
        employeeId
      });
    }
  }
  if (employee.truckCranesMachinistDocument) {
    if (employee.truckCranesMachinistDocument.id) {
      await employeeDocumentApi.updateDocument(employee.truckCranesMachinistDocument);
    } else {
      await employeeDocumentApi.addDocument({
        ...employee.truckCranesMachinistDocument,
        documentType: employeeDocumentTypeEnum.truckCranesMachinist,
        employeeId
      });
    }
  }
  if (employee.manipulatorCranesOperatorDocument) {
    if (employee.manipulatorCranesOperatorDocument.id) {
      await employeeDocumentApi.updateDocument(employee.manipulatorCranesOperatorDocument);
    } else {
      await employeeDocumentApi.addDocument({
        ...employee.manipulatorCranesOperatorDocument,
        documentType: employeeDocumentTypeEnum.manipulatorCranesOperator,
        employeeId
      });
    }
  }
};
export const fetchEmployee = id => async dispatch => {
  const employee = await employeeApi.fetchEmployee(id);
  // Приводим массив документов к объекту с соответсвующими ключами
  // array-callback-return
  const documents = employee.documents.reduce((acc, cur) => {
    if (cur.documentType === employeeDocumentTypeEnum.rigger) {
      return {
        ...acc,
        riggerDocument: cur
      };
    } else if (cur.documentType === employeeDocumentTypeEnum.lulechnik) {
      return {
        ...acc,
        lulechnikDocument: cur
      };
    } else if (cur.documentType === employeeDocumentTypeEnum.safetyTechnician) {
      return {
        ...acc,
        safetyTechnicianDocument: cur
      };
    } else if (cur.documentType === employeeDocumentTypeEnum.safetyCarLift) {
      return {
        ...acc,
        safetyCarLiftDocument: cur
      };
    } else if (cur.documentType === employeeDocumentTypeEnum.controllerGpm) {
      return {
        ...acc,
        controllerGpmDocument: cur
      };
    } else if (cur.documentType === employeeDocumentTypeEnum.carLiftOperator) {
      return {
        ...acc,
        carLiftOperatorDocument: cur
      };
    } else if (cur.documentType === employeeDocumentTypeEnum.truckCranesMachinist) {
      return {
        ...acc,
        truckCranesMachinistDocument: cur
      };
    } else if (cur.documentType === employeeDocumentTypeEnum.manipulatorCranesOperator) {
      return {
        ...acc,
        manipulatorCranesOperatorDocument: cur
      };
    }
    return {
      ...acc
    };
  }, {});
  dispatch(employeeActions.fetch({
    ...employee,
    ...documents
  }));
};
export const cleanEmployee = () => dispatch => dispatch(employeeActions.clean());
export default employeeSlice.reducer;
